import { Backdrop, Box, Button, IconButton, Typography, Zoom } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useDispatch, useSelector } from 'react-redux';
import { selectComponentStore } from '../../system/PageStore';
import { closeVideoList } from '../../system/Slicer/CommonSlicer';
import { VideoLinkItem } from '../../system/Classes/VideoLinkItem';
import { DefaultSetting } from '../defaultSetting';

export interface VideoListPopProps {
    /** 彈窗標題,例如 "數學科活動影片" */
    title?: string;
    data?: VideoLinkItem[];
}

/**
 * 一個 icon 背後載有多條影片連結時,用呢個彈窗列出。
 * 顯示與開關狀態由 CommonSlicer 嘅 videoList 控制,唔使逐個 icon 自己寫 state。
 */
export function VideoListPop(props: VideoListPopProps) {
    const dispatch = useDispatch();
    const componentStates = useSelector(selectComponentStore);
    const open = componentStates.CommonComponentReducer.videoListOpen;
    const items = props.data ?? componentStates.CommonComponentReducer.videoListData ?? [];
    const title = props.title ?? componentStates.CommonComponentReducer.videoListTitle;

    const close = () => {
        dispatch(closeVideoList());
    };

    return (
        <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 2, backgroundColor: "rgba(0,0,0,0.6)" }}
            open={open}
            onClick={close}
        >
            <Zoom timeout={300} in={open}>
                <Box
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                        bgcolor: "background.paper",
                        borderRadius: DefaultSetting.borderRadius,
                        width: { xs: "90vw", sm: "480px" },
                        maxWidth: "90vw",
                        maxHeight: "80vh",
                        overflowY: "auto",
                        p: { xs: 2, sm: 3 },
                        position: "relative",
                    }}
                >
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{ position: "absolute", right: 8, top: 8 }}
                    >
                        <CancelIcon />
                    </IconButton>

                    {title && (
                        <Typography variant="h5" align="left" sx={{ mb: 2, pr: 5, color: DefaultSetting.secondColor }}>
                            {title}
                        </Typography>
                    )}

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                        {items.map((item, index) => (
                            <Button
                                key={index}
                                variant="outlined"
                                startIcon={<PlayArrowIcon />}
                                onClick={() => window.open(item.url, "_blank", "noopener,noreferrer")}
                                sx={{
                                    justifyContent: "flex-start",
                                    textAlign: "left",
                                    textTransform: "none",
                                    py: 1.5,
                                    px: 2,
                                    borderColor: DefaultSetting.mainColor,
                                    color: DefaultSetting.mainColor,
                                    "&:hover": { backgroundColor: "#eaf3fc" },
                                }}
                            >
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                                    {item.year && (
                                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", lineHeight: 1.3 }}>
                                            {item.year}
                                        </Typography>
                                    )}
                                    {item.title && (
                                        <Typography variant="body2" sx={{ color: DefaultSetting.subContentColor }}>
                                            {item.title}
                                        </Typography>
                                    )}
                                </Box>
                            </Button>
                        ))}
                    </Box>
                </Box>
            </Zoom>
        </Backdrop>
    );
}
